export default "__VITE_ASSET__CwoFsry2__"